module.exports = __webpack_public_path__ + "media/images/steps/svg/245-handshake-dab680bd410f7b46068c9488b06ebdcd.svg";